import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/503')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/503"!</div>
}
